import axios from "@/plugins/axios";

const getAll = (params) => {
  return axios.get("/localpost", { params });
};

const getAllBulk = (params) => {
  return axios.get("/localpost/bulk", { params });
};

const getOne = (id) => {
  return axios.get(`/localpost/${id}`);
};

const create = (data) => {
  return axios.post(`/localpost`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const createBulk = (data) => {
  return axios.post(`/localpost/bulk`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const update = (id, data) => {
  return axios.post(`/localpost/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const updateBulk = (data) => {
  return axios.post(`/localpost/bulk`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const destroy = (id) => {
  return axios.delete(`/localpost/${id}`);
};

const destroyBulk = (data) => {
  return axios.post(`/localpost/delete-bulk`, data);
};

const createDeletionTask = (id) => {
  return axios.post(`/localpost/${id}/create-deletion-task`);
};

export default {
  getAll,
  getAllBulk,
  getOne,
  create,
  createBulk,
  update,
  updateBulk,
  destroy,
  destroyBulk,
  createDeletionTask,
};
